import type { ClassValue } from 'clsx';

import { NavbarUtility, NavbarUtilityCount } from '@vs-shop/commerce-ui/navbarUtilities';
import { clsxm, readableCount } from '@vs-shop/utils';

import { Url } from '../../../../route/router';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../utils/intl';

import { IconCartOutline } from '@vs-shop/ui/icons';

type Props = {
  className?: ClassValue;
  /** How many things are in the basket. Derived by {@link NavbarCart}. */
  itemsCount: number;
  isNavigationBlocked: boolean;
  isNavigationUncertain: boolean;
};

/** The basket affordance with something in it. */
export default function NavbarCartActive({
  className,
  itemsCount,
  isNavigationBlocked,
  isNavigationUncertain,
}: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const count = readableCount(itemsCount);

  const cartLabel = intl.formatMessage({
    id: 'navbar.cart.active.link',
    defaultMessage: 'Košík',
  });
  const statusId = 'navbar-cart-navigation-status';

  return (
    <>
      <NavbarUtility
        data-slot="navbar-cart-link"
        className={clsxm('lap:mr-8', className)}
        {...(isNavigationBlocked
          ? {}
          : { render: <a href={Url.cart} title={cartLabel} aria-label={cartLabel} /> })}
        disabled={isNavigationBlocked ? true : undefined}
        aria-label={cartLabel}
        {...(isNavigationBlocked || isNavigationUncertain ? { 'aria-describedby': statusId } : {})}
      >
        <IconCartOutline className="size-7 shrink-0 text-foreground lap:size-8" />
        <NavbarUtilityCount
          data-slot="navbar-cart-count"
          aria-label={intl.formatMessage(
            {
              id: 'navbar.cart.itemsCount',
              defaultMessage: 'Položky v košíku: {count}',
            },
            { count }
          )}
        >
          {count}
        </NavbarUtilityCount>
      </NavbarUtility>
      {(isNavigationBlocked || isNavigationUncertain) && (
        <span
          id={statusId}
          role="status"
          aria-live="polite"
          className="sr-only"
          data-slot="navbar-cart-navigation-status"
        >
          {isNavigationUncertain && !isNavigationBlocked
            ? intl.formatMessage({
                id: 'cartDrawer.pendingLine.unresolved',
                defaultMessage: 'Změnu košíku se nepodařilo ověřit',
              })
            : intl.formatMessage({
                id: 'cartDrawer.navigation.waiting',
                defaultMessage: 'Čekáme na potvrzení změny košíku.',
              })}
        </span>
      )}
    </>
  );
}
